<template>
    <div class="buttons">
        <button class="button is-primary" @click="eventBus.$emit(OPEN_AUTO_SEED_MODAL)">
            <span class="icon">
                <i class="fa fa-tasks" />
            </span>
            <span>
                {{ translate("admin_bracket_listing.generate_all") }}
            </span>
        </button>

        <a :href="urls.eventAdmin().createBracketPage(eventId)" class="button is-light">
            <span class="icon">
                <i class="fa fa-plus"></i>
            </span>
            <span>
                {{ translate("admin_bracket_listing.add_bracket") }}
            </span>
        </a>

        <a
            :href="urls.eventAdmin().disciplinePackagesPage(eventId)"
            class="button"
            :class="{ 'is-warning': store.disciplinesNotConfigured }"
        >
            <span class="icon"><i class="fas fa-layer-group"></i></span>
            <span>
                {{ translate("discipline_packages.configure_disciplines") }}
            </span>
        </a>

        <button class="button" @click="eventBus.$emit(OPEN_MEDAL_PLACES_MODAL)">
            <span class="icon">
                <i class="fas fa-medal"></i>
            </span>
            <span>
                {{ translate("admin_bracket_listing.medal_places") }}
            </span>
        </button>

        <button id="brackets-share-button" class="button" @click="eventBus.$emit(OPEN_SHARE_BRACKETS_MODAL)">
            <span class="icon">
                <i class="fas fa-share-square"></i>
            </span>
            <span>
                {{ translate("admin_share_brackets.title")
                }}<template v-if="store.sharing"
                    >:
                    <span class="has-text-weight-bold" :class="store.sharing.enabled ? 'has-text-success' : 'has-text-danger'">{{
                        translate(
                            store.sharing.enabled
                                ? "admin_bracket_listing.share_brackets_public"
                                : "admin_bracket_listing.share_brackets_hidden",
                        )
                    }}</span></template
                >
            </span>
        </button>

        <button class="button" @click="eventBus.$emit(OPEN_BRACKET_DEFAULTS_MODAL)">
            <span class="icon">
                <i class="fas fa-cog"></i>
            </span>
            <span>
                {{ translate("admin_bracket_listing.defaults_configuration") }}
            </span>
        </button>
    </div>
</template>

<script setup lang="ts">
    import { translate } from "../../Common/translations";
    import urls from "../../Urls/urls";
    import { useBracketsListingStore } from "./bracketsListingApp";
    import {
        eventBus,
        OPEN_AUTO_SEED_MODAL,
        OPEN_MEDAL_PLACES_MODAL,
        OPEN_BRACKET_DEFAULTS_MODAL,
        OPEN_SHARE_BRACKETS_MODAL,
    } from "./eventBus";

    defineProps<{
        eventId: number;
    }>();

    const store = useBracketsListingStore();
</script>

<style scoped></style>
